 	// The module cache
 	var installedModules = {};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}


 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.parastorage.com/services/search-results-widget/1.353.0/";

 	/* runtime version: 1.3.1 */
 	function StylableRuntime(exports){
 	exports = exports || {};
 	function require(){return exports;};

 	(function(){/* source: cached-node-renderer.ts */
 	var CacheStyleNodeRenderer = /** @class */ (function () {
 	    function CacheStyleNodeRenderer(options) {
 	        var _this = this;
 	        this.options = options;
 	        this.create = function (stylesheet, key) {
 	            var node = _this.options.createElement('style');
 	            node.textContent = stylesheet.$css || '';
 	            node.setAttribute(_this.options.attrKey, key);
 	            node.setAttribute('st-depth', stylesheet.$depth + '');
 	            return node;
 	        };
 	        this.hasKey = function (node) { return node.hasAttribute(_this.options.attrKey); };
 	        this.update = function (stylesheet, node) {
 	            if (node.textContent !== stylesheet.$css) {
 	                node.textContent = stylesheet.$css || '';
 	            }
 	            return node;
 	        };
 	        this.renderKey = function (stylesheet) { return stylesheet.$id; };
 	    }
 	    return CacheStyleNodeRenderer;
 	}());
 	exports.CacheStyleNodeRenderer = CacheStyleNodeRenderer;
 	}());
 	(function(){/* source: keyed-list-renderer.ts */
 	function createDOMListRenderer(nodeRenderer) {
 	    var first;
 	    var nodes = {};
 	    var setNode = function (dataItem, node) {
 	        return (nodes[nodeRenderer.renderKey(dataItem)] = node);
 	    };
 	    var renderNode = function (dataItem) {
 	        var key = nodeRenderer.renderKey(dataItem);
 	        var node = nodes[key];
 	        return node
 	            ? nodeRenderer.update(dataItem, node)
 	            : setNode(dataItem, nodeRenderer.create(dataItem, key));
 	    };
 	    var render = function (container, data) {
 	        if (data === void 0) { data = []; }
 	        var node;
 	        if (data.length) {
 	            var next = first;
 	            // tslint:disable-next-line:prefer-for-of
 	            for (var i = 0; i < data.length; i++) {
 	                node = renderNode(data[i]);
 	                if (node !== next) {
 	                    container.insertBefore(node, next || null);
 	                }
 	                else {
 	                    next = node.nextElementSibling;
 	                }
 	            }
 	            first = nodes[nodeRenderer.renderKey(data[0])];
 	            while (node.nextElementSibling) {
 	                if (nodeRenderer.hasKey(node.nextElementSibling)) {
 	                    container.removeChild(node.nextElementSibling);
 	                }
 	                else {
 	                    break;
 	                }
 	            }
 	        }
 	        else {
 	            while (first) {
 	                var next = first.nextElementSibling;
 	                container.removeChild(first);
 	                first = next && nodeRenderer.hasKey(next) ? next : undefined;
 	            }
 	        }
 	    };
 	    return { render: render, nodes: nodes };
 	}
 	exports.createDOMListRenderer = createDOMListRenderer;
 	}());
 	(function(){/* source: css-runtime-renderer.ts */
 	var cached_node_renderer_1 = require("./cached-node-renderer");
 	var keyed_list_renderer_1 = require("./keyed-list-renderer");
 	var RuntimeRenderer = /** @class */ (function () {
 	    function RuntimeRenderer() {
 	        var _this = this;
 	        this.styles = [];
 	        this.stylesMap = {};
 	        this.renderer = null;
 	        this.window = null;
 	        this.id = null;
 	        this.update = function () {
 	            if (_this.renderer) {
 	                _this.renderer.render(_this.window.document.head, _this.styles);
 	            }
 	        };
 	    }
 	    RuntimeRenderer.prototype.init = function (_window) {
 	        if (this.window || !_window) {
 	            return;
 	        }
 	        _window.__stylable_renderer_global_counter =
 	            _window.__stylable_renderer_global_counter || 0;
 	        this.id = _window.__stylable_renderer_global_counter++;
 	        this.window = _window;
 	        this.renderer = keyed_list_renderer_1.createDOMListRenderer(new cached_node_renderer_1.CacheStyleNodeRenderer({
 	            attrKey: 'st-id' + (this.id ? '-' + this.id : ''),
 	            createElement: _window.document.createElement.bind(_window.document)
 	        }));
 	        this.update();
 	    };
 	    RuntimeRenderer.prototype.onRegister = function () {
 	        if (this.window) {
 	            this.window.requestAnimationFrame(this.update);
 	        }
 	    };
 	    RuntimeRenderer.prototype.register = function (stylesheet) {
 	        var registered = this.stylesMap[stylesheet.$id];
 	        if (registered) {
 	            this.removeStyle(registered);
 	        }
 	        var i = this.findDepthIndex(stylesheet.$depth);
 	        this.styles.splice(i + 1, 0, stylesheet);
 	        this.stylesMap[stylesheet.$id] = stylesheet;
 	        this.onRegister();
 	    };
 	    RuntimeRenderer.prototype.removeStyle = function (stylesheet) {
 	        var i = this.styles.indexOf(stylesheet);
 	        if (~i) {
 	            this.styles.splice(i, 1);
 	        }
 	        delete this.stylesMap[stylesheet.$id];
 	    };
 	    RuntimeRenderer.prototype.findDepthIndex = function (depth) {
 	        var index = this.styles.length;
 	        while (index--) {
 	            var stylesheet = this.styles[index];
 	            if (stylesheet.$depth <= depth) {
 	                return index;
 	            }
 	        }
 	        return index;
 	    };
 	    RuntimeRenderer.prototype.getStyles = function (ids, sortIndexes) {
 	        var _this = this;
 	        return this.sortStyles(ids.map(function (id) { return _this.stylesMap[id]; }), sortIndexes);
 	    };
 	    RuntimeRenderer.prototype.sortStyles = function (styles, sortIndexes) {
 	        var _this = this;
 	        if (sortIndexes === void 0) { sortIndexes = false; }
 	        var s = styles.slice();
 	        if (sortIndexes) {
 	            s.sort(function (a, b) {
 	                return _this.styles.indexOf(a) - _this.styles.indexOf(b);
 	            });
 	        }
 	        s.sort(function (a, b) {
 	            return a.$depth - b.$depth;
 	        });
 	        return s;
 	    };
 	    return RuntimeRenderer;
 	}());
 	exports.RuntimeRenderer = RuntimeRenderer;
 	// The $ export is a convention with the webpack plugin if changed both needs a change
 	exports.$ = new RuntimeRenderer();
 	}());
 	(function(){/* source: css-runtime-stylesheet.ts */
 	function create(root, namespace, locals, css, depth, id) {
 	    var dataNamespace = 'data-' + namespace.toLowerCase() + '-';
 	    function cssStates(stateMapping) {
 	        return stateMapping
 	            ? Object.keys(stateMapping).reduce(function (states, key) {
 	                var stateValue = stateMapping[key];
 	                if (stateValue === undefined ||
 	                    stateValue === null ||
 	                    stateValue === false) {
 	                    return states;
 	                }
 	                states[dataNamespace + key.toLowerCase()] = stateValue;
 	                return states;
 	            }, {})
 	            : {};
 	    }
 	    function get(localName) {
 	        return locals[localName];
 	    }
 	    function mapClasses(className) {
 	        return className
 	            .split(/\s+/g)
 	            .map(function (className) { return get(className) || className; })
 	            .join(' ');
 	    }
 	    locals.$root = root;
 	    locals.$namespace = namespace;
 	    locals.$depth = depth;
 	    locals.$id = id;
 	    locals.$css = css;
 	    locals.$get = get;
 	    locals.$cssStates = cssStates;
 	    function stylable_runtime_stylesheet(className, states, inheritedAttributes) {
 	        className = className ? mapClasses(className) : '';
 	        var base = cssStates(states);
 	        if (inheritedAttributes) {
 	            for (var k in inheritedAttributes) {
 	                if (k.match(/^data-/)) {
 	                    base[k] = inheritedAttributes[k];
 	                }
 	            }
 	            if (inheritedAttributes.className) {
 	                className += ' ' + inheritedAttributes.className;
 	            }
 	        }
 	        if (className) {
 	            base.className = className;
 	        }
 	        return base;
 	    }
 	    Object.setPrototypeOf(stylable_runtime_stylesheet, locals);
 	    // EDGE CACHE BUG FIX
 	    stylable_runtime_stylesheet[locals.$root] = locals[locals.$root];
 	    return stylable_runtime_stylesheet;
 	}
 	exports.create = create;
 	function createTheme(css, depth, id) {
 	    return { $css: css, $depth: depth, $id: id, $theme: true };
 	}
 	exports.createTheme = createTheme;
 	}());;
 	return exports;
 	};
 	(typeof self !== 'undefined' ? self : this)["__stylable_yoshi__"] = __webpack_require__.stylable = (typeof self !== 'undefined' ? self : this)["__stylable_yoshi__"] || StylableRuntime();
 	__webpack_require__(/*! ../node_modules/@wix/search-box/dist/src/components/SearchBox/SearchBox.st.css */ 41);
 	__webpack_require__(/*! ../node_modules/@wix/search-results-layouts/dist/src/components/ListLayout/ListLayoutItem.st.css */ 45);
 	__webpack_require__(/*! ../node_modules/@wix/search-results-layouts/dist/src/components/GridLayout/GridLayoutItem.st.css */ 69);
 	__webpack_require__(/*! ../node_modules/wix-ui-tpa/dist/src/components/Tabs/Tabs.st.css */ 74);
 	__webpack_require__(/*! ../node_modules/wix-ui-tpa/dist/src/components/Pagination/Pagination.st.css */ 75);
 	__webpack_require__(/*! ../node_modules/wix-ui-core/dist/src/components/dropdown-option/DropdownOption.st.css */ 77);
 	__webpack_require__(/*! ../node_modules/@wix/search-results-layouts/dist/src/components/GridLayout/GridLayout.st.css */ 97);
 	__webpack_require__(/*! ../node_modules/@wix/search-results-layouts/dist/src/components/ListLayout/ListLayout.st.css */ 99);
 	__webpack_require__(/*! ../node_modules/@wix/search-results-layouts/dist/src/components/ViewAllButton/ViewAllButton.st.css */ 162);
 	__webpack_require__(/*! ../node_modules/@wix/search-results-layouts/dist/src/components/SampleLayout/SampleLayout.st.css */ 163);
 	__webpack_require__(/*! ../node_modules/wix-ui-tpa/dist/src/components/Tabs/Tab/Tab.st.css */ 177);
 	__webpack_require__(/*! ../node_modules/wix-ui-tpa/dist/src/components/Tabs/ScrollableTabs/ScrollableTabs.st.css */ 178);
 	__webpack_require__(/*! ../node_modules/wix-ui-tpa/dist/src/components/Tabs/TabsNavButton/TabsNavButton.st.css */ 179);
 	__webpack_require__(/*! ../node_modules/wix-ui-core/dist/src/components/pagination/Pagination.st.css */ 182);
 	__webpack_require__(/*! ../node_modules/wix-ui-core/dist/src/components/dropdown/Dropdown.st.css */ 187);
 	__webpack_require__(/*! ../node_modules/wix-ui-core/dist/src/components/popover/Popover.st.css */ 192);
 	__webpack_require__(/*! ../node_modules/wix-ui-core/dist/src/components/dropdown-content/DropdownContent.st.css */ 193);
 	__webpack_require__(/*! ../node_modules/wix-ui-core/dist/src/components/input/Input.st.css */ 195);
 	__webpack_require__(/*! ../node_modules/wix-ui-core/dist/src/hocs/Focusable/Focusable.st.css */ 197);
 	__webpack_require__(/*! ../node_modules/@wix/search-box/dist/src/components/SuggestionFooter/SuggestionFooter.st.css */ 199);
 	__webpack_require__(/*! ../node_modules/@wix/search-box/dist/src/components/SuggestionHeader/SuggestionHeader.st.css */ 200);
 	__webpack_require__(/*! ../node_modules/@wix/search-results/dist/src/components/TotalResults/TotalResults.st.css */ 201);
 	__webpack_require__(/*! ../node_modules/wix-ui-core/dist/src/components/circular-progress-bar/CircularProgressBar.st.css */ 203);
 	__webpack_require__(/*! ../node_modules/@wix/search-results/dist/src/components/DemoContentNotification/DemoContentNotification.st.css */ 204);
 	__webpack_require__(/*! ../node_modules/@wix/search-results/dist/src/components/SearchResults/SearchResults.st.css */ 205);
 	__webpack_require__(/*! ./components/Widget/Widget.st.css */ 216);
 	__webpack_require__(/*! ./components/WidgetRoot/WidgetRoot.st.css */ 218);
 	__webpack_require__(/*! ../node_modules/@wix/search-results-layouts/dist/src/components/ImageCover/ImageCover.st.css */ 263);
 	__webpack_require__(/*! ../node_modules/@wix/search-results-layouts/dist/src/components/Thumbnail/Thumbnail.st.css */ 264);
 	__webpack_require__(/*! ../node_modules/@wix/search-results-layouts/dist/src/components/Title/Title.st.css */ 266);
 	__webpack_require__(/*! ../node_modules/@wix/search-results-layouts/dist/src/components/Price/Price.st.css */ 269);
 	__webpack_require__(/*! ../node_modules/@wix/search-results-layouts/dist/src/components/Description/Description.st.css */ 273);
 	__webpack_require__(/*! ../node_modules/wix-ui-core/dist/src/components/input-with-options/InputWithOptions.st.css */ 385);
 	__webpack_require__(/*! ../node_modules/wix-ui-core/dist/src/components/deprecated/divider/Divider.st.css */ 420);
 	__webpack_require__(/*! ../node_modules/wix-ui-core/dist/src/components/button-next/button-next.st.css */ 430);
 	__webpack_require__(/*! ../node_modules/@wix/search-box/dist/src/components/ClearButton/ClearButton.st.css */ 434);
 	__webpack_require__(/*! ../node_modules/@wix/search-box/dist/src/components/RatioBox/RatioBox.st.css */ 438);
 	__webpack_require__(/*! ../node_modules/@wix/search-results/dist/src/components/SearchInput/SearchInput.st.css */ 447);
 	__webpack_require__(/*! ../node_modules/@wix/search-results/dist/src/components/Spinner/Spinner.st.css */ 456);
 	__webpack_require__(/*! ./assets/styles/preview-reset.st.css */ 518);
 	if(typeof window !== 'undefined') { __webpack_require__.stylable.$.init(window); }

 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 522);
